import { account } from "utils/axiosInstances";
import { camelize, snakeify } from "utils/objectUtilities";

const URL = "/invoice-data";

export const getInvoiceData = async () => {
  try {
    const response = await account.get(URL);
    return camelize(response.data, true);
  } catch (error) {
    const { response } = error;
    throw new Error(response.message, response.status);
  }
};

export const editInvoiceData = async (payload) => {
  try {
    const response = await account.put(URL, snakeify(payload, true));
    return camelize(response.data, true);
  } catch (error) {
    const { response } = error;
    throw new Error(response.message, response.status);
  }
};

export const createInvoiceData = async (payload) => {
  try {
    const response = await account.post(URL, snakeify(payload, true));
    return camelize(response.data, true);
  } catch (error) {
    const { response } = error;
    throw new Error(response.message, response.status);
  }
};
